const CDN = "https://cdn.prod.website-files.com/602f5458a0b1d868c6c84d5b";

const logos = [
  { src: `${CDN}/6910cc55979af174280b9f3e_Group%20(2).svg`, alt: "" },
  { src: `${CDN}/6910cd2d43a9203e7ece72e2_g43.svg`, alt: "" },
  { src: `${CDN}/618cf7d27e8255e6af866c7b_Roche.svg`, alt: "Roche" },
  { src: `${CDN}/6910cf070dc7f93e800af8be_Ryanair%201.svg`, alt: "Ryanair" },
  { src: `${CDN}/6910cf0d2562409136668c19_Publicis_logo%201.svg`, alt: "Publicis" },
  { src: `${CDN}/6910cf14a66ae9bf48ba573d_Schneider_Electric_2007%201.svg`, alt: "Schneider Electric" },
  { src: `${CDN}/64d22435a83397855c43ab85_PMKuwait.svg`, alt: "PM Kuwait" },
  { src: `${CDN}/6910cefaf02d084a2754d157_Group%20(3).svg`, alt: "" },
  { src: `${CDN}/6910cf021d08a6ac28e0d04d_New_York_University_Seal%201.svg`, alt: "NYU" },
  { src: `${process.env.PUBLIC_URL}/pg-BXHMeVKW.png`, alt: "P&G" },
  { src: `${CDN}/64d22435de9e6dbbc3c9b869_RelianceGI.svg`, alt: "Reliance" },
  { src: `${CDN}/60e7e09742981b2497ca3634_EY.svg`, alt: "EY" },
  { src: `${CDN}/62c0692270fae10b801562e1_Deloitte.svg`, alt: "Deloitte" },
];

export default function LogoMarquee() {
  return (
    <section className="py-14 bg-white overflow-hidden border-t border-b border-[#F0F0F0]">
      <div className="max-w-[1200px] mx-auto px-6 mb-14">
        <p className="text-center text-[#08080899] text-sm font-semibold tracking-widest uppercase">
          Trusted by the world&apos;s leading enterprises
        </p>
      </div>
      <div className="relative">
        <div className="flex" style={{ width: "max-content", animation: "marquee-landing 18s linear infinite" }}>
          {[...logos, ...logos].map((logo, i) => (
            <div key={i} className="inline-flex items-center justify-center flex-shrink-0 h-8 w-[120px] mr-20">
              <img
                src={logo.src}
                alt={logo.alt || 'logo'}
                style={{ height: '42px', width: 'auto', maxWidth: '180px', objectFit: 'contain' }}
                className="grayscale opacity-60 hover:opacity-100 hover:grayscale-0 transition-all duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
